// cookieStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';


type CookiePreferences = {
  calendly: boolean;
};

type CookieStore = {
  preferencesSet: boolean;
  preferences: CookiePreferences;
  
  calendly: {
    use: boolean;
    type: string;
  }

  setPreferences: (prefs: CookiePreferences) => void;
  resetPreferences: () => void;
  setCalendlyAccess: (use: boolean, type?: string ) => void;
};

export const useCookieStore = create<CookieStore>()(
  persist(
    (set) => ({
      preferencesSet: false,
      preferences: { calendly: false },

      calendly: {
        use: false,
        type: "",
      },

      setPreferences: (prefs) =>
        set({
          preferences: prefs,
          preferencesSet: true,
        }),

      resetPreferences: () =>
        set({
          preferencesSet: false,
          preferences: { calendly: false },
          calendly: { use: false, type: "" },
        }),

        setCalendlyAccess: (use, type = "null") => {
        console.log('[Zustand] setCalendlyAccess', { use, type });
        set({
            calendly: {
            use,
            type,
            },
        });
        },
    }),
    {
      name: 'cookie-preferences',
    }
  )
);
